import EmblaCarousel from 'embla-carousel';
import { addWheelScroll } from '../helpers/embla-wheel-scroll';

function setButtonState(button: HTMLButtonElement, disabled: boolean): void {
  button.disabled = disabled;
  button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
}

export default function testimonialCarousel(root: HTMLElement): void {
  const viewport = root.querySelector<HTMLElement>('[data-carousel-viewport]');
  const prevBtns = [...root.querySelectorAll<HTMLButtonElement>('[data-carousel-prev]')];
  const nextBtns = [...root.querySelectorAll<HTMLButtonElement>('[data-carousel-next]')];
  const dotsRoots = [...root.querySelectorAll<HTMLElement>('[data-carousel-dots]')];
  const navRoots = [...root.querySelectorAll<HTMLElement>('.testimonial-carousel__nav')];
  const status = root.querySelector<HTMLElement>('[data-carousel-status]');
  const slideRoots = [...root.querySelectorAll<HTMLElement>('[data-carousel-slide]')];

  slideRoots.forEach(slideRoot => {
    const hasRenderedSlide = slideRoot.querySelector('.testimonial-carousel-slide');

    if (!hasRenderedSlide) {
      slideRoot.remove();
    }
  });

  const slides = [...root.querySelectorAll<HTMLElement>('[data-carousel-slide]')];

  slides.forEach((slide, index) => {
    slide.dataset.variant = index % 2 === 0 ? 'base' : 'alternate';
  });

  if (slides.length === 0) {
    root.setAttribute('hidden', 'true');
    return;
  }

  if (slides.length <= 1) {
    navRoots.forEach(navRoot => {
      navRoot.setAttribute('hidden', 'true');
    });
  }

  if (
    !viewport ||
    prevBtns.length === 0 ||
    nextBtns.length === 0 ||
    dotsRoots.length === 0 ||
    !status
  ) {
    return;
  }

  const embla = EmblaCarousel(viewport, {
    loop: false,
    align: 'start',
    dragFree: false,
    containScroll: 'trimSnaps'
  });

  addWheelScroll(viewport, embla);

  const dotsByRoot = dotsRoots.map(dotsRoot => {
    dotsRoot.innerHTML = '';

    return slides.map((_, index) => {
      const dot = document.createElement('span');
      const dotCore = document.createElement('span');
      dot.dataset.carouselDot = String(index);
      dot.className = 'testimonial-carousel__dot';
      dotCore.className = 'testimonial-carousel__dot-core';
      dot.appendChild(dotCore);
      dotsRoot.appendChild(dot);
      return dot;
    });
  });

  const syncUi = (): void => {
    const selectedIndex = embla.selectedScrollSnap();
    const canPrev = embla.canScrollPrev();
    const canNext = embla.canScrollNext();

    prevBtns.forEach(button => setButtonState(button, !canPrev));
    nextBtns.forEach(button => setButtonState(button, !canNext));

    dotsByRoot.forEach(dots => {
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === selectedIndex;
        dot.toggleAttribute('data-active', active);
      });
    });

    status.textContent = `Testimonial ${selectedIndex + 1} of ${slides.length}`;
  };

  prevBtns.forEach(button => {
    button.addEventListener('click', () => embla.scrollPrev());
  });

  nextBtns.forEach(button => {
    button.addEventListener('click', () => embla.scrollNext());
  });
  root.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft') {
      embla.scrollPrev();
    } else if (event.key === 'ArrowRight') {
      embla.scrollNext();
    }
  });

  embla.on('select', syncUi);
  embla.on('reInit', syncUi);
  syncUi();
}
